import React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import { Helmet } from 'react-helmet';

import banner from '../images/banner.jpg';

const ContactContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const BannerSection = styled.section`
  width: 100%;
  background-color: #0099ff;
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  margin-bottom: 0.5rem;
`;

const BannerImage = styled.div`
  width: 80%;
  height: 250px;
  background-image: url(${banner});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: 768px) {
    width: 95%;
    height: 180px;
  }
`;

const WelcomeSection = styled.section`
  padding: 0 5rem 2rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 0 2rem 1rem;
  }
`;

const WelcomeTitle = styled.h2`
  font-size: 2.4rem;
  color: #0099ff;
  margin: 0 0 1rem;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const WelcomeText = styled.p`
  color: #333;
  line-height: 1.6;
  font-size: 1rem;
`;

// ✅ 只保留这一个 export default
export default function ContactPage() {
  return (
    <Layout>
      <Helmet>
        <title>Contact us - Wisdom Home Appliances</title>
        <meta name="description" content="Contact Wisdom home appliances" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <ContactContainer>
        <BannerSection>
          <BannerImage />
        </BannerSection>

        <WelcomeSection>
          <WelcomeTitle>Contact us</WelcomeTitle>
          <WelcomeText>
            South Wisdom International Development Limited<br />
            Address: Rooms 1318-20, 13/F, Hollywood Plaza,610 Nathan Road, <br />
            Mongkoko, Kowloon, Hong Kong<br />
            Tel:+852-27108200 ext 7240 <br />
            Fax:+852-27108266<br />
            Email:info@southwisdomltd.com
          </WelcomeText>
        </WelcomeSection>
      </ContactContainer>
    </Layout>
  );
}